export default "__VITE_ASSET__BPwM_2fk__"